import React, { memo } from 'react'
import { Col, Form, Input, Popover, Alert, Row } from 'antd'
import PropTypes from 'prop-types'
import { hexToRGBA, specialFieldValidation } from '../../../../../lib/utils'

const CustomRow = ({ children }) => {
  return <Row gutter={[16, 16]}>{children}</Row>
}

const ContactDetailsSection = ({ form, specialFormState, setSpecialFormState, countryObject, token, userData }) => {
  // Check if this is a dependant with main member details
  const hasMainMemberDetails = userData?.mainMemberId && userData?.mainMemberName

  return (
    <CustomRow gutter={[16, 16]}>
      {/* Main Member Details Section */}
      {hasMainMemberDetails && (
        <Col span={24}>
          <Alert
            type='info'
            message={
              <div
                style={{
                  fontWeight: 600,
                  color: token.colorTextHeading,
                  marginBottom: 8
                }}
              >
                Main Member Details
              </div>
            }
            description={
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: '8px 16px',
                  fontSize: '14px'
                }}
              >
                <div>
                  <strong>Name:</strong> {userData.mainMemberName}
                </div>
                <div>
                  <strong>ID Number:</strong> {userData.mainMemberIdNo}
                </div>
                {userData.tmpPhoneNumber && (
                  <div>
                    <strong>Phone:</strong> {userData.tmpPhoneNumber}
                  </div>
                )}
                {userData.tmpEmail && (
                  <div>
                    <strong>Email:</strong> {userData.tmpEmail}
                  </div>
                )}
              </div>
            }
            style={{
              marginBottom: 16,
              borderRadius: 8,
              border: `1px solid ${hexToRGBA(token.colorInfo, 0.2)}`,
              backgroundColor: hexToRGBA(token.colorInfo, 0.05)
            }}
          />
        </Col>
      )}

      {/* Dependant Contact Details Section */}
      <Col span={24}>
        {hasMainMemberDetails && (
          <div
            style={{
              marginBottom: 16,
              color: token.colorTextSecondary,
              fontSize: '14px'
            }}
          >
            You can add additional contact details for the dependant below:
          </div>
        )}

        <CustomRow gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name='phoneNumber'
              label='Phone Number'
              rules={[
                {
                  required: !hasMainMemberDetails,
                  message: 'Please input phone number'
                }
              ]}
              tooltip={hasMainMemberDetails ? 'Optional additional contact number for dependant' : undefined}
            >
              <Input addonBefore='+27' placeholder='Phone Number' maxLength={10} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name='email'
              label='Email'
              rules={[
                {
                  type: 'email',
                  message: 'Please enter a valid email'
                }
              ]}
              tooltip={hasMainMemberDetails ? 'Optional additional email for dependant' : undefined}
            >
              <Input placeholder='Email' />
            </Form.Item>
          </Col>
        </CustomRow>
      </Col>
    </CustomRow>
  )
}

ContactDetailsSection.propTypes = {
  form: PropTypes.object.isRequired,
  specialFormState: PropTypes.array.isRequired,
  setSpecialFormState: PropTypes.func.isRequired,
  countryObject: PropTypes.object,
  token: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired
}

export default ContactDetailsSection
